<p class="text-success success-message text-center" [id]="idPrefix + 'general-success-message'">{{ message }}</p>
